import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PendingTakedownStatusUpdate,
  PendingTakedownStatusUpdatesState,
} from './types';

const initialState: PendingTakedownStatusUpdatesState = {
  items: [],
};

// Results normally arrive within seconds; anything older than this never got
// one (request-level failure, WS outage) and is dropped on the next enqueue.
export const PENDING_STATUS_UPDATE_TTL_MS = 10 * 60 * 1000;

const pendingTakedownStatusUpdatesSlice = createSlice({
  name: 'pendingTakedownStatusUpdates',
  initialState,
  reducers: {
    addPendingTakedownStatusUpdates: (
      state,
      action: PayloadAction<PendingTakedownStatusUpdate[]>,
    ) => {
      const cutoff = Date.now() - PENDING_STATUS_UPDATE_TTL_MS;
      const fresh = state.items.filter(
        item =>
          new Date(item.startedAt).getTime() > cutoff &&
          !action.payload.some(added => added.takedownId === item.takedownId),
      );
      state.items = [...fresh, ...action.payload];
    },
    removePendingTakedownStatusUpdates: (
      state,
      action: PayloadAction<string[]>,
    ) => {
      state.items = state.items.filter(
        item => !action.payload.includes(item.takedownId),
      );
    },
  },
});

export const {
  addPendingTakedownStatusUpdates,
  removePendingTakedownStatusUpdates,
} = pendingTakedownStatusUpdatesSlice.actions;

export default pendingTakedownStatusUpdatesSlice.reducer;
